import { createQueryKeys } from "@lukemorales/query-key-factory";
import { get, PaginatedResponse } from "@/api/api";
import { useSuspenseQuery } from "@tanstack/react-query";
import { SensorKitConfig } from "@/sensorKitConfigs/types";
import { SensorKitModel } from "@/sensorKits/sensorKit";

export interface SensorKitConfigFilters {
  model?: SensorKitModel;
}

export const sensorKitConfigs = createQueryKeys('sensor-kit-configs', {
  list: (filters?: SensorKitConfigFilters) => ({
    queryKey: ["list", filters],
    queryFn: async () => {
      let url = `/sensor-kit-configs/`;
      const params = new URLSearchParams();

      if (filters?.model) {
        params.append('model', filters.model);
      }

      params.append('page_size', '100');

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      return await get<PaginatedResponse<SensorKitConfig>>(url);
    },
  })
});

export const useSensorKitConfigs = (filters?: SensorKitConfigFilters) => {
  return useSuspenseQuery(sensorKitConfigs.list(filters))
}
